import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  POST_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH,
  PostOrganizationLimitedAccessOrganizationErrorDto,
  PostOrganizationLimitedAccessOrganizationRequestBodyData,
  PostOrganizationLimitedAccessOrganizationRequestPathVariables,
  PostOrganizationLimitedAccessOrganizationRequestQueryParams,
  PostOrganizationLimitedAccessOrganizationSuccessDto,
} from './types/limitedAccessOrganization';

export const usePostLimitedAccessOrganization = () => {
  return useApiPostRequest<
    PostOrganizationLimitedAccessOrganizationRequestPathVariables,
    PostOrganizationLimitedAccessOrganizationRequestQueryParams,
    PostOrganizationLimitedAccessOrganizationRequestBodyData,
    PostOrganizationLimitedAccessOrganizationSuccessDto,
    PostOrganizationLimitedAccessOrganizationErrorDto
  >(POST_ORGANIZATION_LIMITED_ACCESS_ORGANIZATION_PATH);
};
